/**
 * Returns the display name for a staff member, prioritizing their Codename.
 * 
 * Priority:
 * 1. user.staffDetails.codename
 * 2. user.staffDetails.businessData.codename
 * 3. user.name (fallback)
 * 
 * @param {Object} user - The user object from AuthContext
 * @returns {string} The name to display
 */
export const getStaffDisplayName = (user) => {
    if (!user) return '';

    // Check strict codename paths first
    const contractCodename = user?.staffDetails?.contractData?.codename;
    const preStaffCodename = user?.staffDetails?.preStaffData?.codename;
    const directCodename = user?.staffDetails?.codename;
    const businessCodename = user?.staffDetails?.businessData?.codename;

    // Return the first valid codename found, priority order:
    // 1. Contract Data (Most reliable for active staff)
    // 2. Pre-Staff Data (For onboarding/training)
    // 3. Direct Codename (Legacy/Direct set)
    // 4. Business Data (Fallback)
    if (contractCodename && contractCodename.trim() !== '') return contractCodename;
    if (preStaffCodename && preStaffCodename.trim() !== '') return preStaffCodename;
    if (directCodename && directCodename.trim() !== '') return directCodename;
    if (businessCodename && businessCodename.trim() !== '') return businessCodename;

    return user.name || 'Staff';
};
